import React, { useState, useEffect } from "react";
import { Button, Form, DatePicker, Radio, Popconfirm, Space } from "antd";
import PropTypes from "prop-types";
import { QuestionCircleOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;

export const FilterTransaction = ({
	loading = false,
	onFilterTransactions = () => {},
	isTransactionsEdited = false,
}) => {
	const [ form ] = Form.useForm();
	const [ isButtonDisabled, setIsButtonDisabled ] = useState(true);
	const [ dateFilterType, setDateFilterType ] = useState("single"); // "single" or "range"

	const isFormValid = () => {
		const values = form.getFieldsValue();

		// Check if the correct date field is selected
		const dateValid =
			(dateFilterType === "single" && values.month) || // Single month selected
			(dateFilterType === "range" && values.months?.length === 2); // Range selected

		// Ensure dateValid is true and other fields are optional
		return dateValid;
	};

	useEffect(() => {
		setIsButtonDisabled(!isFormValid());
	}, [form, dateFilterType]);

	const handleFilterTransactions = async () => {
		const values = form.getFieldsValue();
		onFilterTransactions(values);
	};

	return (		
		<Form 
			form={form} 
			name="transactionForm"
			layout="center"
			autoComplete="off"
			initialValues={{labels: []}}
			onValuesChange={() => {
				setIsButtonDisabled(!isFormValid());
			}}
		>	
			<Space direction="horizontal">
				{dateFilterType === "single" && (
					<Form.Item name="month">
						<DatePicker style={{ marginRight: "5px", marginTop: "10px" }} picker="month" loading={loading} />
					</Form.Item>
				)}

				{dateFilterType === "range" && (
					<Form.Item name="months">
						<RangePicker style={{ marginRight: "5px", marginTop: "10px" }} picker="month" loading={loading} />
					</Form.Item>
				)}

				<Radio.Group
					style={{ marginRight: "5px" }}
					onChange={(e) => setDateFilterType(e.target.value)}
					value={dateFilterType}
				>
					<Radio.Button loading={loading} value="single">Individual</Radio.Button>
					<Radio.Button loading={loading} value="range">Rango</Radio.Button>
				</Radio.Group>

				{isTransactionsEdited ? 						
					<Popconfirm
						title="Obtener Nuevas Transacciones"
						description="Tienes Transacciones en edición todavía ¿Estas seguro que quieres continuar?"
						onConfirm={handleFilterTransactions} 
						icon={<QuestionCircleOutlined style={{ color: "red" }} />}
					>
						<Button type="primary" disabled={isButtonDisabled}>
							Buscar
						</Button>
					</Popconfirm>
					: 
					<Button
						type="primary"
						disabled={isButtonDisabled}
						onClick={handleFilterTransactions}
						loading={loading}
					>
						Buscar
					</Button>
				}
			</Space>
		</Form>		
	);
};

FilterTransaction.displayName = "FilterTransaction";

FilterTransaction.propTypes = {
	loading: PropTypes.bool,
	onFilterTransactions: PropTypes.func.isRequired,
	isTransactionsEdited: PropTypes.bool,
};
